import Vue from 'vue'
import VueResource from 'vue-resource'

Vue.use(VueResource)

// URL and endpoint constants
const API_URL = process.env.API_BASE_URL

// Send a request to the login URL. When using JWT, will just probably uncomment these lines

const authenticated = () => {
  const AUTH_URL = API_URL + '/auth'
  let config = {
    method: 'get',
    url: AUTH_URL,
    responseType: 'json',
    credentials: true
  }
  return Vue.http(config)
}

const logout = () => {
  const LOGOUT_URL = API_URL + '/logout'
  let config = {
    method: 'post',
    url: LOGOUT_URL,
    responseType: 'json',
    credentials: true
  }
  return Vue.http(config)
}

export default {
  authenticated,
  logout
}



// WEBPACK FOOTER //
// ./src/utils/auth.js